import { render, staticRenderFns } from "./atacSeq.vue?vue&type=template&id=60da5da0&"
import script from "./atacSeq.vue?vue&type=script&lang=js&"
export * from "./atacSeq.vue?vue&type=script&lang=js&"
import style0 from "./atacSeq.vue?vue&type=style&index=0&id=60da5da0&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports